module.exports = __webpack_public_path__ + "img/multi_image04.65745bce.png";